export default __webpack_public_path__ + "static/media/ttr_Presentation_Q2_2024.17f11bdd.pdf";